import { css, cva } from "@styled-system/css";
import { flex, grid } from "@styled-system/patterns";

export const listClass = css({
	display: "flex",
	flexDirection: "column",
	marginTop: "8",
});

export const wrongAnswerSpacing = css({
	mt: "10",
	mb: "16",
});
export const orderLearnCorrectAnswerWrapper = css({
	cursor: "pointer",
});

export const orderLearnCorrectAnswerContainer = grid({
	gridTemplateColumns: "12",
	gap: "2",
	padding: "4",
});

export const orderLearnCorrectAnswerIconWrapper = flex({
	gridColumn: "[span 1 / span 1]",
	alignItems: "start",
	justifyContent: "center",
});

export const orderLearnCorrectAnswerContent = css({
	gridColumn: "[span 11 / span 11]",
	ml: "10",
});

export const orderLearnCorrectAnswerTitle = css({
	fontWeight: "bold",
	fontSize: "12",
	color: "success.100",
	mb: "4",
});
export const getAnswerStatusColorClass = (status: string) =>
	css({
		color: status === "actuallyCorrect" ? "success.100" : "error.100",
	});

export const answerStatusColor = cva({
	base: {},
	variants: {
		status: {
			actuallyCorrect: {
				color: "success.100",
			},
			correct: {
				color: "error.100",
			},
		},
	},
});

export const cardItemWrapperClass = css({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "16",
});
